import React from 'react'
import { connect } from 'react-redux'
import WarehouseActions from '../../Redux/WarehouseRedux'

class UpdateWarehouse extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      warehouse: {
        id: props.detail.id || '',
        name: props.detail.name || '',
        address: props.detail.address || '',
        detail_info: props.detail.detail_info || ''
      }
    }
  }

  _inputChange = (event, field) => {
    let value = event.target.value
    let warehouse = {...this.state.warehouse}
    warehouse[field] = value
    this.setState({ warehouse })
  }

  _submit = (event) => {
    event.preventDefault()
    let form = {...this.state.warehouse}
    const data = {
      id: this.props.detail.id,
      form
    }
    this.props.updateWarehouse(data)
    setTimeout(() => {
      this.props.closeModal()
    }, 250)
  }

  render () {
    return (
      <div className='section' style={{ width: '40vw' }}>
        <div className='title-block'>
          <h4 className='title mr-auto'>Update Warehouse</h4>
        </div>
        <form onSubmit={(event) => this._submit(event)}>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Edit Name</label>
            </div>
            <div className='col-9'>
              <input
                type='text'
                required
                placeholder='Warehouse name'
                className='form-control'
                value={this.state.warehouse.name}
                onChange={(event) => this._inputChange(event, 'name')}
              />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Edit Address</label>
            </div>
            <div className='col-9'>
              <textarea
                required
                rows='3'
                placeholder='Warehouse name'
                className='form-control'
                value={this.state.warehouse.address}
                onChange={(event) => this._inputChange(event, 'address')}
              />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Edit Details</label>
            </div>
            <div className='col-9'>
              <textarea
                required
                rows='3'
                placeholder='Warehouse Name'
                className='form-control'
                value={this.state.warehouse.detail_info}
                onChange={(event) => this._inputChange(event, 'detail_info')}
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-12 text-right'>
              <button type='button' className='btn btn-secondary mr-2' onClick={() => this.props.closeModal()}>Cancel</button>
              <button type='submit' className='btn btn-primary'>Save</button>
            </div>
          </div>
        </form>
      </div>
    )
  }
}

const stateToProps = (state) => ({})

const dispatchToProps = (dispatch) => ({
  updateWarehouse: (data) => dispatch(WarehouseActions.updateWarehouseRequest(data))
})

export default connect(stateToProps, dispatchToProps)(UpdateWarehouse)



// WEBPACK FOOTER //
// ./src/Containers/Ecommerce/UpdateWarehouse.js